/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize CountryUserRoles Creation View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './CountryUserRolesCreationView';

export const mapStateToPropsCURCreation = mapStateToProps;
export const mapDispatchToPropsCURCreation = mapDispatchToProps;

export default connect(
  mapStateToPropsCURCreation,
  mapDispatchToPropsCURCreation
)(View);
